/*
function numberWithCommas(x)
{
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
*/

// Format a number n using: 
//   p decimal places (two by default)
//   ts as the thousands separator (comma by default) and
//   dp as the  decimal point (period by default).
//
//   If p < 0 or p > 20 results are implementation dependent.
function formatNumber(n, p, ts, dp) {
  var t = [];
  // Get arguments, set defaults
  if (typeof p  == 'undefined') p  = 2;
  if (typeof ts == 'undefined') ts = ',';
  if (typeof dp == 'undefined') dp = '.';

  // Get number and decimal part of n
  n = Number(n).toFixed(p).split('.');

  // Add thousands separator and decimal point (if requied):
  for (var iLen = n[0].length, i = iLen? iLen % 3 || 3 : 0, j = 0; i <= iLen; i+=3) {
    t.push(n[0].substring(j, i));
    j = i;
  }
  // Insert separators and return result
  return t.join(ts) + (n[1]? dp + n[1] : '');
}

/*
	Price search module in the property search form.
*/
OC__Price_search = {
	
	init : function(){
		
		//----------------------------------------------------------
		// PRICE FORM
		
		// Init UI.
		OC__Price_search.init_ui();
		OC__Price_search.check_ui();
		
		jQuery.validator.addMethod( 'check_guest_total', function(value, element){
			// Get guest counts.
			var adults_count = OC__Price_search.get_guests_adults_count();
			var children_count = OC__Price_search.get_guests_children_count();
			// Get total sleeps.
			var total_guests_count = OC__Price_search.get_guests_total_count();
			
			// Check if we have a guest count.
			if( total_guests_count < 0 )
			{
				// No guest count - return true.
				return( true );
			}
			
			// Assess whether total guest limit is exceeded by form entries.
			var test_guest_count = ( (adults_count + children_count) <= total_guests_count );
						
			return( test_guest_count );
		});
		
		var validate_form = jQuery('#property-price-search').validate({
			rules: {
				arrival: {
					required: true,
					//dateISO: true,
				}
				,
				departure: {
					required: true,
					//dateISO: true
				}
				,
				sleeps_adults: {
					required: true,
					check_guest_total: true,
				}
				,
				sleeps_children: {
					//required: true,
					check_guest_total: true,
				}
			}
			,
			messages: {
				arrival: {
					required: 'Please supply an arrival date',
					dateISO: 'Please supply a correctly formatted date'
				}
				,
				departure: {
					required: 'Please supply a departure date',
					dateISO: 'Please supply a correctly formatted date'
				}
				,
				sleeps_adults: {
					required: 'Please supply adult guests count',
					check_guest_total: 'Please ensure the total guests does not exceed the property limit',
				}
				,
				sleeps_children: {
					required: 'Please supply child guests count',
					check_guest_total: 'Please ensure the total guests does not exceed the property limit',
				}
			}
			,
			submitHandler: function(form) {
				OC__Price_search.get_price_alert();
				//form.submit();
				console.log('SUBMIT!!!');
				// Emit event. After Property Detail Search submit.
				var options = {};
				options.form = jQuery(form);
				jQuery(document).trigger('oc_property_detail_search_submit',options);
			}
		});
		
		// Allow for datepickers not triggering focus loss on fields.
		//jQuery('#arrival').datepicker('option','onClose',function(){
			//validate_form.element( '#arrival' );
		//});
		//var value = jQuery('#arrival').val();
		//jQuery('#arrival').val(value);
		//jQuery('#arrival').datepicker('option', { 
			//onClose: function(selected_date){
				//validate_form.element( '#arrival' );
			//}
		//});
		//jQuery('#departure').datepicker('option', { 
			//onClose: function(selected_date){
				//validate_form.element( '#departure' );
			//}
		//});
		/*
		// Collect property price search form details to return a quote.
		jQuery('#property-price-search').submit(function(event){
			
			//OC__Price_search.get_price_alert();
			//event.preventDefault();
			
		});
        
        
        */
        
        // Reset Booking link on click.
        jQuery( '#property-price-search-alert .booking-link' ).click(function(event){
			
			//var validate_form = validate_form.form();
			var validate_form = jQuery('#property-price-search').valid();
			
			if(validate_form)
			{
				// Get guest counts.
				var adults_count = OC__Price_search.get_guests_adults_count();
				var children_count = OC__Price_search.get_guests_children_count();
				
				// Get check in/ check out dates in correct format.
				var start_date = OC__Price_search.get_start_date();
				var end_date = OC__Price_search.get_end_date();
				
				// Get property ID.
				var property_id = OC__Price_search.get_property_id();
				
				// Assemble booking link.
				var sb_booking_link = oc__property_settings.paths.securebookit.booking;
				var booking_link = sb_booking_link + '?inc=1&id=' + property_id + '&start_date=' + start_date + '&end_date=' + end_date + '&adults=' + adults_count + '&children=' + children_count;
				
				// Reset link.
				jQuery(this).attr('href',booking_link);
				
				//event.preventDefault();
			}
			else
			{
				event.preventDefault();	
			}      
	        
        });
        
        // Reset Enquiry link on click.
        jQuery( '#booking .booking-tools .enquiry > a' ).click(function(event){
	        
	        // Check if the search form validates.
			///var validate_form = jQuery('#property-price-search').valid();
			
			///if(validate_form)
			///{
				// Get guest counts.
				var adults_count = OC__Price_search.get_guests_adults_count();
				var children_count = OC__Price_search.get_guests_children_count();
				
				// Get check in/ check out dates in correct format.
				var start_date = OC__Price_search.get_start_date();
				var end_date = OC__Price_search.get_end_date();
				
				// Get property ID.
				var property_id = OC__Price_search.get_property_id();
				
				// Get the existing link.
				var current_link = jQuery(this).attr('href');
				
				// Assemble booking link.
				var sb_enquiry_link = current_link;//oc__property_settings.paths.securebookit.booking;
								
				// Check if arrival date is valid. Currently using the moment.js library.
				if(start_date != 'Invalid date')
				{
					// Append the arrival date to the Enquiry link.
					sb_enquiry_link += '&start_date=' + start_date;
				}
				
				// Check if departure date is valid. Currently using the moment.js library.
				if(end_date != 'Invalid date')
				{
					// Append the departure date to the Enquiry link.
					sb_enquiry_link += '&end_date=' + end_date;
				}
				
				// Ensure the Adult Count is at least zero.
				adults_count = Math.max(adults_count,0);
				// Append the Adults Count to the Enquiry link.
				sb_enquiry_link += '&adults=' + adults_count;
				
				// Ensure the Child Count is at least zero.
				children_count = Math.max(children_count,0);
				// Append the Child Count to the Enquiry link.
				sb_enquiry_link += '&children=' + children_count;
				
				//var booking_link = sb_enquiry_link + '?inc=1&id=' + property_id + '&start_date=' + start_date + '&end_date=' + end_date + '&adults=' + adults_count + '&children=' + children_count;
				
				// Reset link.
				jQuery(this).attr('href',sb_enquiry_link);
				
			///}
			///else
			///{
			///	event.preventDefault();	
			///}
	    });
        
        // Setup datepicker for arrival and departure fields.
		OC__Price_search.set_datepicker();
		
		// Run the price alert box setup once on initialisation.
		OC__Price_search.get_price_alert();
        
        //----------------------------------------------------------
      
	}
	,
	check_ui : function()
	{
		var is_open = jQuery( '#property-price-search-alert' ).hasClass('open');
		
		if( is_open )
		{
			// Hide alternate booking tools button.
			jQuery('.booking-tools .book').hide();
		}
		else
		{
			// Show alternate booking tools button.
			jQuery('.booking-tools .book').show();
		}
	}
	,
	init_ui : function() // Setup UI on the first run.
	{
		// Fire functionality on user setting Adults sleeps.
		jQuery('#property-price-search select[name="sleeps_adults"]').on('change',function(pm_event){
			// Additional pricing can arise from extra Adults.
			OC__Price_search.get_price_alert();
			OC__Price_search.reset_ui();
		});
		
		// Fire functionality on user setting Children sleeps.
		jQuery('#property-price-search select[name="sleeps_children"]').on('change',function(pm_event){
			// Additional pricing can arise from extra Children.
			OC__Price_search.get_price_alert();
			OC__Price_search.reset_ui();
		});
		
		// Force children to off.
		//jQuery('#property-price-search select[name="sleeps_children"]').attr('readonly', true);
	}
	,
	reset_ui : function() // Reset UI subsequent to the first run.
	{
		// Get guest counts.
		var adults_count = OC__Price_search.get_guests_adults_count();
		var children_count = OC__Price_search.get_guests_children_count();
		
		// Get max total sleeps.
		var total_guests_count = OC__Price_search.get_guests_total_count();
		
		// Get maximums.
		var max_adults = OC__Price_search.get_max_guests_adults();
		var max_children = OC__Price_search.get_max_guests_children();
		
		// Available sleeps (for selecting children) is controlled by the adults selection.
		var available_sleeps = total_guests_count - adults_count;
		
		// Default the child select maximum to the available sleeps.
		var children_select_max = max_children;
		
		// Ensure that the child select maximum does not exceed the designated child maximum.
		// The agent can select the absolute limit on children for this property.
		if (available_sleeps < children_select_max)
		{
			children_select_max = available_sleeps; 
		}
		//children_select_max = Math.min(available_sleeps,children_select_max);
		
		// Record the child select elements on page load for reload.
		var child_option = jQuery('#property-price-search select[name="sleeps_children"] option:eq(0)');
		var child_label = child_option.text();
		var child_value = child_option.val();
		
		// Reset the child select with default option.
		jQuery('#property-price-search select[name="sleeps_children"]').empty();
		var selected = (children_count < 0) ? ' selected="selected"' : '';
		jQuery('#property-price-search select[name="sleeps_children"]').append('<option value="' + child_value + '"' + selected + '>' + child_label + '</option>');
		
		// Reload the child select options up to the child maximum.
		for(var i=0; i <= children_select_max; i++)
		{
			var selected = (children_count == i) ? ' selected="selected"' : '';
			jQuery('#property-price-search select[name="sleeps_children"]').append('<option value="' + i + '"' + selected + '>' + i + '</option>');
		}
				
		// Force children to on.
		//jQuery('#property-price-search select[name="sleeps_children"]').attr('readonly', false);
	}
	,
	format_price : function(pm_price)
	{
		// Get the parameter.
		var price = pm_price;
		
		// May well be a string. Float it.
		price = parseFloat(price);
		
		// Check for NaN bread.
		if(isNaN(price))
		{
			price = 0;
		}
		
		return(price);
	}
	,
	get_price_alert : function()
	{
		// Get check in/ check out dates in correct format.
		var start_date = OC__Price_search.get_start_date();
		var end_date = OC__Price_search.get_end_date();
		
		// Validate dates.
		if( (start_date == 'Invalid date') || (end_date == 'Invalid date') )
		{
			return(false);
		}
		
		// Get guest counts.
		var adults_count = OC__Price_search.get_guests_adults_count();
		var children_count = OC__Price_search.get_guests_children_count();
		
		// Get property ID.
		var property_id = OC__Price_search.get_property_id();
			
		// Assemble service call.
		var active_pricing_call = 'https://securebookit.com.au/api/service/getBulkRTTariff.php?arrive=' + start_date + '&depart=' + end_date + '&idlist=' + property_id + '&adults=' + adults_count + '&children=' + children_count;
		
		var active_pricing_call2 = 'https://securebookit.com.au/api/service/realtimePropertyService_production.php';
		active_pricing_call2 += '?service=live_price';
		active_pricing_call2 += '&id=' + property_id;
		active_pricing_call2 += '&start=' + start_date;
		active_pricing_call2 += '&end=' + end_date;
		active_pricing_call2 += '&adults=' + adults_count;
		active_pricing_call2 += '&children=' + children_count;
		active_pricing_call2 += '&code=';
		//https://securebookit.com.au/api/service/realtimePropertyService_production.php?service=live_price&id=3115646438172277230014Q&start=Saturday%2016%20April%202022&end=Friday%2022%20April%202022&adults=2&children=0&code=
			
		// Set alert box to loading mode.
		jQuery('#property-price-search-alert').addClass('loading');
			
		// Open alert box.
		jQuery('#property-price-search-alert, #booking').addClass('open');
		jQuery('#booking').removeClass('reset');
		
		// Remove discount classes to search form and body (Default).
		jQuery( 'body' ).removeClass('oc-discount-applied');
		jQuery( '#property-price-search-alert' ).removeClass('discounted');
		
		// Check UI.
		OC__Price_search.check_ui();
		
		// Assemble AJAX call.
		jQuery.post( active_pricing_call2, function( data ) {
			
			// Get parameters.
			var bond = data.bond;
			var sleeps = data.sleeps;
			var linen_fee = data.linen_fee;
			var amenities = data.amenities;
			var from_price = data.sb_from_price;
			var error = data.sb_message_error;
			var status = data.sb_message_status;
			var live_price = data.sb_live_price;
			var booking_fee = data.sb_book_fee;
			var clean_included = data.cleanIncluded;
			var cleaning_fee = data.cleanFee;
			var deposit = data.deposit;
			var tariff_total = data.tariff_total;
			var deposit_available = data.deposit_available;
			var discount_start = data.discount_start;
			var discount_end = data.discount_end;
			var discount_name = data.discount_name;
			var review = data.review;
			var is_special = data.is_special;
			var extra_people_cost = data.extra_people_cost;
			var webservicefee_charge = data.webservicefee_charge;
			
			// Get price.
			var price = OC__Price_search.format_price(live_price) + OC__Price_search.format_price(booking_fee) + OC__Price_search.format_price(amenities) + OC__Price_search.format_price(linen_fee) + OC__Price_search.format_price(extra_people_cost) + OC__Price_search.format_price(webservicefee_charge);
			var price_formatted = formatNumber(price, 2, ',', '.');
			var price_display = '';
			
			var booking_alert_html = '';
			var title = '';
			var description = '';
			
			if( error != '' )
			{
				title = '';//'Sorry!';
				description = 'We could not calculate a booking at this time.';
				jQuery('#property-price-search-alert').addClass('error');
				jQuery('#property-price-search-alert .error').show();
				jQuery('#property-price-search-alert .price').hide();
				jQuery( '#property-price-search-alert .booking-link' ).hide();
			}
			else
			{
				if( status == 'available' )
				{
					title = 'Available!';
					description = 'We have calculated your stay';
					price_display = '<span class="denomination">$</span>' + '<span class="amount">' + price_formatted + '</span>';
					
					var sb_booking_link = oc__property_settings.paths.securebookit.booking;
					
					var booking_link = sb_booking_link + '?inc=1&id=' + property_id + '&start_date=' + start_date + '&end_date=' + end_date + '&adults=' + adults_count + '&children=' + children_count;
					jQuery( '#property-price-search-alert .booking-link' ).attr('href',booking_link);
					jQuery( '#property-price-search-alert .booking-link' ).show();
					jQuery('#property-price-search-alert').removeClass('error');
					jQuery('#property-price-search-alert .error').hide();
					jQuery('#property-price-search-alert .price').show();
					
					// Add discount classes to search form and body.
					if( is_special )
					{
						jQuery( 'body' ).addClass('oc-discount-applied');
						jQuery( '#property-price-search-alert' ).addClass('discounted');
					}
				}
				else
				{
					title = 'Unavailable';
					description = 'Sorry, these dates are unavailable.';
				}
			}
						
			// Set elements
			jQuery('#property-price-search-alert .title h3').text(title);
			var display_title = (title == '');
			jQuery('#property-price-search-alert .title').toggleClass('hide',display_title);
			jQuery('#property-price-search-alert .error').text(error);
			jQuery('#property-price-search-alert .description').text(description);
			jQuery('#property-price-search-alert .price').html(price_display);
			
			// Set alert box to not loading.
			jQuery('#property-price-search-alert').removeClass('loading');
			
			var options = {}
			options.data = data;
			options.booking_html = jQuery('#property-price-search-alert').html();
			options.foo = 'bar';
			jQuery(document).trigger('oc__property_booking_update',options);
			
			// Check UI.
			OC__Price_search.check_ui();

		});
	}
	,
	get_guests_adults_count : function()
	{
		// Look in form field.
		var adults_count = jQuery('select[name="sleeps_adults"]').val();
		
		// If unset default to -1.
		if (typeof adults_count == 'undefined' || adults_count == '')
		{
			adults_count = -1;
		}
		
		// Make sure it's a number.
		adults_count = parseInt(adults_count);
		
		return(adults_count);
	}
	,
	get_max_guests_adults : function()
	{
		// Track maximum adults count.
		var max_adults = -1;
		
		// Check for our on-page parameter object. This will contain data for the Property Detail Page.
		if(typeof oc_property_page_data === 'undefined')
		{
			return(max_adults);
		}
		
		// Look in form attribute.
		//var max_adults = jQuery('form#property-price-search').attr('data-max-adults');
		max_adults = oc_property_page_data.property.features.sleeps.max_adults;
		
		// If unset default to -1.
		if (typeof max_adults == 'undefined' || max_adults == '')
		{
			max_adults = -1;
		}
		
		// Make sure it's a number.
		max_adults = parseInt(max_adults);
		
		return(max_adults);
	}
	,
	get_guests_children_count : function()
	{
		// Look in form field.
		var children_count = jQuery('select[name="sleeps_children"]').val();
		
		// If unset default to -1.
		if (typeof children_count == 'undefined' || children_count == '')
		{
			children_count = -1;
		}
		
		// Make sure its a number.
		children_count = parseInt(children_count);
		
		return(children_count);
	}
	,
	get_max_guests_children : function()
	{
		// Track total guests count.
		var max_children = -1;
		
		// Check for our on-page parameter object. This will contain data for the Property Detail Page.
		if(typeof oc_property_page_data === 'undefined')
		{
			return(max_children);
		}
		
		// Look in form attribute.
		//var max_children = jQuery('form#property-price-search').attr('data-max-children');
		max_children = oc_property_page_data.property.features.sleeps.max_children;
		
		// If unset default to -1.
		if (typeof max_children == 'undefined' || max_children == '')
		{
			max_children = -1;
		}
		
		// Make sure it's a number.
		max_children = parseInt(max_children);
		
		return(max_children);
	}
	,
	get_guests_total_count : function()
	{
		// Track total guests count.
		var total_guests_count = -1;
		
		// Check for our on-page parameter object. This will contain data for the Property Detail Page.
		if(typeof oc_property_page_data === 'undefined')
		{
			return(total_guests_count);
		}
		
		// Get the total sleeps maximum from our on-page object.
		total_guests_count = oc_property_page_data.property.features.sleeps.value;
		
		// If unset default to -1.
		if (typeof total_guests_count == 'undefined' || total_guests_count == '')
		{
			total_guests_count = -1;
		}
		
		// Make sure its a number.
		total_guests_count = parseInt(total_guests_count);
		
		return(total_guests_count);
	}
	,
	get_start_date : function()
	{
		// Get check in date in correct format.
		var start_date = jQuery('#arrival').val();
		start_date = moment(start_date).format('YYYY-MM-DD');
		
		// Moment JS is popping out dates with minus at the front.
		if(start_date.charAt(0) == '-')
		{
			start_date = start_date.substring(1);
		}
		
		return(start_date);
	}
	,
	get_end_date : function()
	{
		// Get check out date in correct format.
		var end_date = jQuery('#departure').val();
		end_date = moment(end_date).format('YYYY-MM-DD');
		
		// Moment JS is popping out dates with minus at the front.
		if(end_date.charAt(0) == '-')
		{
			end_date = end_date.substring(1);
		}
		
		return(end_date);
	}
	,
	get_property_id : function()
	{
		var property_id = '';
		
		// Look for Property ID holder. Used in legacy sites.
		if( jQuery('#oc-property-id-holder').length > 0 )
		{
			// Use the data attribute to get the Property ID.
			property_id = jQuery('#oc-property-id-holder').attr('data-property-id');
			
			// If value is found then return it.
			if(property_id != '')
			{
				return(property_id);
			}
		}
		
		// Get property ID.
		
		//Start with URL parameters.
		var current_url = window.location.href;
		
		// Try get parameter.
		var start_index = current_url.indexOf('property_id=');
		if( start_index > 0 )
		{
			start_index += 12;
		}
		
		// If not found then try slug parameter.
		if( start_index < 0 )
		{
			start_index = current_url.indexOf('property/');
			if( start_index > 0 )
			{
				start_index += 9;
			}
		}
		
		// Extract Property ID if we have a start ID.
		if( start_index > 0 )
		{
			var end_index = start_index + 23;
			var property_id = current_url.substring( start_index, end_index );
		}
		
		return(property_id);
	}
	,
	set_datepicker : function()
	{
	    //----------------------------------------------------------
		// PRICE FORM DATE PICKERS.  
	    
	    if( jQuery('#property-price-search').size() > 0 )
	    {
			//var current_url = window.location.href;
			//var start_index = current_url.indexOf('property/') + 9;
			//var end_index = start_index + 23;
			var property_id = OC__Price_search.get_property_id();//current_url.substring( start_index, end_index );
			
			var calendar_id = 'availability_' + property_id;
			var month_count = 1;
		
					
			var today = new Date();
			today.setHours(0);
			today.setSeconds(0);
			today.setMinutes(0);
			today.setMilliseconds(0);
			var twoYears = new Date(today.valueOf());
			twoYears.dateAdd("yyyy",2);
			var availabilityString = new String(jQuery("#" + calendar_id + " .av").html());
			var avSt = new String(jQuery("#" + calendar_id + " .startDate").html());
			var avStartDate = new Date();
			avStartDate.setYear(avSt.substr(0,4));
			switch(avSt.substr(5,2)){
				case '01':
					var mon = 0;
					break;
				case '02':
					var mon = 1;
					break;
				case '03':
					var mon = 2;
					break;
				case '04':
					var mon = 3;
					break;
				case '05':
					var mon = 4;
					break;
				case '06':
					var mon = 5;
					break;
				case '07':
					var mon = 6;
					break;
				case '08':
					var mon = 7;
					break;
				case '09':
					var mon = 8;
					break;
				case '10':
					var mon = 9;
					break;
				case '11':
					var mon = 10;
					break;
				case '12':
					var mon = 11;
					break;
			}
			avStartDate.setMonth(mon);
			avStartDate.setDate(avSt.substr(8,2));
			avStartDate.setHours(0);
			avStartDate.setSeconds(0);
			avStartDate.setMinutes(0);
			avStartDate.setMilliseconds(0);
			if(availabilityString.length>0){
				var lad = new Date(avStartDate.valueOf());
				lad.dateAdd("d",availabilityString.length-1);
			}
			function isbooked(d){
				if(availabilityString.length>0 && d>=avStartDate && d<=lad){
					var x = daysDifferent(avStartDate,d);
					var avStr = availabilityString.substr(x,1);
					return parseInt(avStr);
				}
				return 0;
			}
	
			function nextBooking(sd){
				var nb = new Date(sd.valueOf());
				nb.dateAdd("m",3); //Max Three Months
	
				if(availabilityString.length>0 && sd>=avStartDate && sd<=lad){
					var dd = new Date(avStartDate.valueOf());
					for (var x = daysDifferent(avStartDate,sd); dd<lad; x++){
	
						var dd = new Date(avStartDate.valueOf());
						dd.dateAdd("d",x+1);
	
						if(dd>sd){
							if(parseInt(availabilityString.substr(x,1)) > 0){
								return dd;
							}
						}
					}
				}
				return nb;
			}
	
	
			var selectEnd = false;
			var StartDate = null;
			var EndDate = null;
			var nextBookingDate = null;
	
			var monthsView = 1;
			if(parseFloat(jQuery("#" + calendar_id + " .monthview").text()) > 1){
				monthsView = parseFloat(jQuery("#" + calendar_id + " .monthview").text());
			}
	
			jQuery("#property-price-search #arrival, #property-price-search #departure").datepicker({
	
				dateFormat: 'd M yy',
				minDate: today,
				maxDate: twoYears,
				beforeShow: function(input, inst){
					// Having issues with Gravity Forms styles conflicts.
					//jQuery(inst).addClass('gform-legacy-datepicker');
					jQuery('#ui-datepicker-div').addClass('gform-legacy-datepicker');
				},
				beforeShowDay: function(d){
					if(d>=today){
						var tomorrow = new Date(d.valueOf());
						tomorrow.dateAdd("d",1);
						var yesterday = new Date(d.valueOf());
						yesterday.dateAdd("d",-1);
	
						var bookingClass = "";
						var selectable = true;
						var toolTip = "Select Arrival Date";
						if(!EndDate && StartDate){
							var toolTip = "Select Departure Date";
						}
	
						var ybooking = isbooked(yesterday)
						var booking = isbooked(d);
						if(booking == 0){
							if(ybooking == 1){
								selectable = true;
								bookingClass = "pending-end";
							}
							else if(ybooking == 2){
								selectable = true;
								bookingClass = "booking-end";
							}
							else if(ybooking == 3){
								selectable = true;
								bookingClass = "booking-owner-end";
							}
						}
						else if(booking == 1){
							if(yesterday >= today && ybooking == 0){
								bookingClass = "pending-start";
								if(selectEnd){
									selectable = true;
								}
								else{
									toolTip = "Pending Booking";
									selectable = false;
								}
							}
							else{
								toolTip = "Pending Booking";
								selectable = false;
								bookingClass = "pending";
							}
						}
						else if(booking == 2){
							if(yesterday >= today && ybooking == 0){
								bookingClass = "booking-start code-2";
								if(selectEnd){
									selectable = true;
								}
								else{
									//toolTip = "Unavailable";
									//selectable = false;
								}
							}
							else{
								toolTip = "Unavailable";
								selectable = false;
								bookingClass = "booking";
							}
						}
						else if(booking == 3){
							if(yesterday >= today && ybooking == 0){
								bookingClass = "booking-owner-start";
								if(selectEnd){
									selectable = true;
								}
								else{
									toolTip = "Unavailable";
									selectable = false;
								}
							}
							else{
								toolTip = "Unavailable";
								selectable = false;
								bookingClass = "booking-owner";
							}
						}
						
						else if(booking == 4){
							if(yesterday >= today && ybooking == 0){
								bookingClass = "booking-back-to-back";
								if(selectEnd){
									selectable = true;
								}
								else{
									toolTip = "Unavailable Back to Back Booking";
									selectable = false;
								}
							}
							else{
								toolTip = "Unavailable Back to Back Booking";
								selectable = false;
								bookingClass = "booking-owner-back-to-back";
							}
						}
						
						if(selectEnd){
							if(d<=StartDate || d>=nextBookingDate){
								selectable = false;
								toolTip = "Unavailable";
								if(d.valueOf()!=StartDate.valueOf()){
									bookingClass+= " fade-out";
								}
							}
						}
						if(StartDate){
							if(d.valueOf()==StartDate.valueOf()){
								bookingClass+= " booking-selected-start";
							}
							if(EndDate){
								if(d>StartDate && d<EndDate){
									bookingClass+= " booking-selected";
								}
								else if(d.valueOf()==EndDate.valueOf()){
									bookingClass+= " booking-selected-end";
								}
							}
						}
					}
					return [selectable,bookingClass,toolTip];
				},
				numberOfMonths: monthsView * month_count,
				onSelect:function(dateText, inst){
					
					var datepicker_id = inst['id'];
					
					if( datepicker_id == 'arrival' )
					{
						jQuery("#departure").datepicker("option","minDate", dateText);
						
						OC__Price_search.get_price_alert();
					}
								
					if( datepicker_id == 'departure' )
					{
						jQuery("#arrival").datepicker("option","maxDate", dateText);
						
						OC__Price_search.get_price_alert();
					}
					
					// Transmit event.
					var options = {}
					options.dateText = dateText;
					options.instance = inst;
					options.datepicker_id = datepicker_id;
					jQuery(document).trigger('oc__property_booking_date_update',options);
					
				},
				onClose:function(dateText, inst)
				{
					var validate_form = jQuery('#property-price-search').valid();
					//validate_form.element( '#arrival' );
					//validate_form.element( '#departure' );
				}
			}).on('changeDate',function(event){
				var validate_form = jQuery('#property-price-search').valid();
			});
			
			///jQuery("#property-price-search #arrival, #property-price-search #departure").each(function(pm_index){
				///jQuery(this).parent().append('<button class="clear">Clear</button');
			///});	
		}
						
		//----------------------------------------------------------------------------------		
	}
}

jQuery(document).ready(function(jQuery){

	OC__Price_search.init();

});